(() => {
  const WORLD_PARAM = 'filter.p.m.custom.geschenkwelten';
  const PRICE_MIN_PARAM = 'filter.v.price.gte';
  const PRICE_MAX_PARAM = 'filter.v.price.lte';

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-ah-xmas-filter]');
    if (
      !link ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
      (link.target || '').toLowerCase() === '_blank' ||
      link.hasAttribute('download')
    ) return;

    const url = new URL(window.location.href);
    const fallback = new URL(link.href, window.location.href);
    if (!url.searchParams.has('view') && fallback.searchParams.has('view')) {
      url.searchParams.set('view', fallback.searchParams.get('view'));
    }

    if (link.dataset.ahXmasFilter === 'world') {
      const value = link.dataset.filterValue;
      const currentWorlds = url.searchParams
        .getAll(WORLD_PARAM)
        .flatMap((entry) => entry.split(','))
        .map((entry) => entry.trim());
      const isActive = currentWorlds.includes(value);
      url.searchParams.delete(WORLD_PARAM);
      if (value && !isActive) url.searchParams.set(WORLD_PARAM, value);
    }

    if (link.dataset.ahXmasFilter === 'budget') {
      url.searchParams.delete(PRICE_MIN_PARAM);
      url.searchParams.delete(PRICE_MAX_PARAM);
      if (Number(link.dataset.priceMin) > 0) url.searchParams.set(PRICE_MIN_PARAM, link.dataset.priceMin);
      if (Number(link.dataset.priceMax) > 0) url.searchParams.set(PRICE_MAX_PARAM, link.dataset.priceMax);
    }

    url.searchParams.delete('page');
    url.hash = 'geschenkideen';
    event.preventDefault();
    window.location.assign(url.toString());
  });
})();
